import { UserInterface, UserVarsMap } from "@swivl-mono/types";
import { Button } from "@swivl-mono/ui";
import { useSearchParams } from "react-router-dom";

import { DataCardLocation } from "../../../../../Components/DataCards/DataCard.Location";
import Pill, { PillSize, PillStyle, PillType } from "../../../../../Components/Pill/Pill";
import { getDescriptionAndImageForUnit } from "../../../../../Helpers/getImageAndDescriptionForUnit";
import { AlertsModel } from "../../../../../Models/Notifications/Alerts.Model";
import { UnitsModel } from "../../../../../Models/Units/Units.Model";

interface UserDetailsUnitDetailsViewProps {
  navigateForward: (tab?: string) => void;
  user: UserInterface;
  userVars: UserVarsMap | undefined;
}

export function UserDetailsUnitDetailsView({ navigateForward, user, userVars }: UserDetailsUnitDetailsViewProps) {
  const [searchParams] = useSearchParams();
  const locationId = Number(searchParams.get("locationId"));
  const { unitsByLocation } = UnitsModel.useState((s) => s);
  const selectedUnitId = Number(searchParams.get("unitId"));
  const selectedUnit = unitsByLocation?.[locationId]?.find((unit) => unit.id === selectedUnitId);

  const { description, imageURL } = getDescriptionAndImageForUnit(selectedUnit);

  const handleCreateLead = () => {
    AlertsModel.errorToast("This feature is not available yet.");
    return;
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="mb-4">
        {/* layout => title-only */}
        <DataCardLocation
          title="Prospect Profile"
          locationId={locationId}
          pills={[<Pill key={`pill-${locationId}`} type={PillType.AQUA} size={PillSize.SMALL} style={PillStyle.DARK} text="Prospect" />]}
        />
      </div>

      <img alt="example of unit dimensions" className="max-h-80 w-full rounded-md bg-grey-50 object-cover shadow-md" src={imageURL} />

      {/* dimensions and price */}
      <div className="mt-2 flex items-center justify-between text-xl font-semibold">
        <span>{selectedUnit?.dimensions || "--"}</span>
        <span>{selectedUnit?.rate ? `$${selectedUnit.rate}` : "--"}</span>
      </div>

      {/* amenities pills */}
      <div className="flex items-center gap-2">
        {selectedUnit?.raw.unit_amenities?.map((amenity) => (
          <Pill key={amenity.id} type={PillType.DEFAULT} size={PillSize.MEDIUM} style={PillStyle.LIGHT} text={amenity.name} />
        ))}
      </div>

      {/* unit description */}
      <div className="my-2">
        <p>{description}</p>
      </div>

      {/* unit management buttons */}
      <div className="grid grid-cols-2 gap-3">
        <Button fullWidth onClick={handleCreateLead}>
          <span aria-label="pencil" role="img">
            ✏️
          </span>{" "}
          Create Lead
        </Button>
        <Button fullWidth onClick={handleCreateLead}>
          <span aria-label="ticket" role="img">
            🎟️
          </span>{" "}
          Create Reservation
        </Button>
        <Button fullWidth onClick={handleCreateLead}>
          <span aria-label="right arrow" role="img">
            ➡️
          </span>{" "}
          Move in Customer
        </Button>
        <Button fullWidth onClick={handleCreateLead}>
          <span aria-label="chat bubble" role="img">
            💬
          </span>{" "}
          Copy to Message
        </Button>
      </div>
    </div>
  );
}
